module.exports = __webpack_public_path__ + "static/media/WALKER AUDIO PROSCENIUM BLACK DIAMOND MKII TURNTABLE.d617fa9c.png";